import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const presenceAnnounceAtom = createMutationAtomFactory(
  'iot.presenceAnnounce',
  (params: {
    room: string;
    metadata: Record<string, unknown>;
    sessionId?: string;
  }) => ({
    presenceAnnounce: {
      __args: {
        room: params.room,
        metadata: params.metadata,
        sessionId: params.sessionId,
      },
    },
  }),
  {
    skipQueue: true,
    showLoadingOverlay: false,
    retries: 0,
  },
);
